<template>
	<div class="donate page">
		<div class="item">
			<div class="name"><span>Skinbox Only <div class="small mh"> Choose any skin on any item</div></span> <small class="price">5 EUR</small> <small>Permanent</small></div>
		</div>

		<div class="item">
			<div class="name"><span>[ VIP ] Bundle</span> <small class="price">10 EUR</small> <small>Permanent</small></div>
			<li><i class="fas fa-spray-can"></i> Skinbox <small>Choose any skin on any item</small></li>
			<li><i class="far fa-person-booth"></i> Skip Queue <small>No more waiting in queue</small></li>
			<li><i class="fas fa-tag"></i> [VIP/VIP+] <small>Nametag in the chat</small></li>
		</div>
		
		<div class="item">
			<div class="name"><span>[ VIP+ ] Bundle</span> <small class="price">15 EUR</small> <small>Permanent</small></div>
			<li><i class="fas fa-arrow-alt-to-top"></i> All features from VIP listed above</li>
			<li><i class="fas fa-brush"></i> A unique chat tag in the color you want</li>
			<li><i class="fas fa-house-flood"></i> Access to ' Water Bases ' to build Bases on the Water!</li>
			<li><i class="fas fa-inbox"></i> Access to ' Box Sorting ' to organize your box with ease</li>
			<li><i class="fas fa-paint-brush"></i> Access to ' Building Skins ' for all available materials</li>
		</div>

		<div class="methods">
			<div class="smalltext">Payments methods:</div>
			<span>PayPal & Credit Card</span> <span>CS:GO Skins</span> <span>Rust Skins</span> <span>Steam Giftcard</span> <span>PaySafeCard</span>
		</div>
		
		<div class="links">
			<div class="smalltext">Consider donating? Join our Discord or add the Owner on Steam!</div>
			<a href="https://discord.gg/QUZvG6b" target="_blank"><i class="fab fa-discord"></i> Discord</a>
			<a href="https://steamcommunity.com/id/therealtoxic" target="_blank"><i class="fab fa-steam"></i> Steam Profile</a>
			<a href="https://steamcommunity.com/tradeoffer/new/?partner=75084246&token=Bg2F1VmO" target="_blank"><i class="fab fa-steam"></i> Trade Link</a>
			<a href="https://www.paypal.com/donate/?hosted_button_id=FLPUGRURX6PVL" target="_blank"><i class="fab fa-paypal"></i> PayPal & Card</a>
		</div>
	</div>
</template>


<script>
export default {
	name: "Donate",
};
</script>


<style lang="scss">
.donate.page {
	.item {
		padding: 9px 25px;
		border-radius: 10px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		background-color: rgba(0, 0, 0, 0.3);
		margin-bottom: 10px;

		.name {
			font-size: 24px;
			font-weight: 600;
			display: flex;
			justify-content: space-between;
			align-items: center;
			// margin-bottom: 10px;

			// &.nm {
			// 	margin-bottom: 0px;
			// }

			span {
				flex: 1 auto;
				// display: flex;
				// justify-content: space-between;
				// align-items: center;
			}

			small {
				font-size: 15px;
				padding: 4px 10px;
				background-color: #e34541; //#f56565;
				color: white;
				border-radius: 7px;

				&.price {
					background-color: #38a565;
					margin-right: 10px;
					width: 72px;
					text-align: center;
				}
			}
		}

		li {
			list-style: none;
			line-height: 1.4;
			font-size: 15px;

			i {
				width: 30px;
			}

			small {
				opacity: 0.7;
				margin-left: 10px;
				font-weight: 400;
			}
		}

		.small {
			opacity: 0.7;
			margin-left: 10px;
			font-size: 14px;
			font-weight: 400;
			display: inline;
		}
	}

	.smalltext {
		text-align: center;
		display: block;
		opacity: 0.5;
		font-size: 14px;
	}

	.methods {
		text-align: center;

		span {
			display: inline-block;
			margin: 5px;
		}
	}

	.links {
		// margin-top: 10px;
		text-align: center;
		.smalltext {
			margin-bottom: 10px;
		}

		a {
			display: inline-block;
			padding: 5px 15px;
			border: 1px solid white;
			border-radius: 6px;
			margin: 0px 5px;
			transition: 0.25s;
			cursor: pointer;

			&:hover {
				background-color: rgba(255, 255, 255, 0.1);
			}
		}
	}

	@media screen and (max-width: 1200px) and (orientation: portrait) {
		.item {
			padding: 2vw 3vw;

			.mh {
				display: none;
			}

			.name {
				font-size: 4vw;
				margin-bottom: 2vw;

				small {
					font-size: 3vw;
				}
			}

			&:first-child .name {
				margin-bottom: 0px;
			}

			li {
				font-size: 3.5vw;
				i {
					width: 5vw;
				}
			}
		}

		.links a {
			display: block;
			padding: 2vw;
			margin: 0px;
			margin-top: 2vw;
		}
	}
}
</style>